import { Box, MenuItem, Pagination, TextField, type TablePaginationProps } from '@mui/material';
import {
  gridPageCountSelector,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

export const DATA_GRID_NUMBERED_PAGE_SIZE_OPTIONS = [10, 25, 50] as const;
export const DATA_GRID_DEFAULT_PAGE_SIZE = DATA_GRID_NUMBERED_PAGE_SIZE_OPTIONS[0];

/** Footer pagination: rows-per-page select + MUI `Pagination` (numbered pages), matching master DataGrid UX. */
export function DataGridNumberedPagination(
  /** Injected by DataGrid `slots.pagination`; unused — state comes from the grid API. */
  _slotProps: Partial<TablePaginationProps>,
) {
  const pageSizeOptions = DATA_GRID_NUMBERED_PAGE_SIZE_OPTIONS;
  const apiRef = useGridApiContext();
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: 2,
        px: 1,
        py: 1,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <TextField
        select
        size="small"
        label="Rows per page"
        value={paginationModel.pageSize}
        onChange={(e) => {
          const pageSize = Number(e.target.value);
          apiRef.current.setPaginationModel({ page: 0, pageSize });
        }}
        sx={{ width: 128 }}
      >
        {pageSizeOptions.map((n) => (
          <MenuItem key={n} value={n}>
            {n}
          </MenuItem>
        ))}
      </TextField>
      <Pagination
        color="primary"
        showFirstButton
        showLastButton
        count={Math.max(pageCount, 1)}
        page={pageCount > 0 ? paginationModel.page + 1 : 1}
        onChange={(_, value) => apiRef.current.setPage(value - 1)}
        disabled={pageCount === 0}
      />
    </Box>
  );
}
